import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const StaffMemberRoute = lazyWithRetries(() => import('./StaffMemberRoute'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.staffMember(':staffId'),
    element: (
      <StandardPageLayout elementId="staffMemberRoute" maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <StaffMemberRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
